var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"MainWrapper"}},[_c('div',{attrs:{"id":"MainContent"}},[(this.$store.state.count>0)?_c('div',[_c('top-header',{attrs:{"show_admin_menu":_vm.show_admin_menu}}),_c('router-view'),_c('Footer')],1):_vm._e(),(this.$store.state.count==0)?_c('div',[_c('Login')],1):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }